<template>
	<div>
		
		
			<el-row :gutter="20">
				  <el-col :span="24">

				  	<div class="grid-content d-flex bg-white px-3 py-3">
				  		<el-image
						      style="width: 80px; height: 80px"
						      src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-image>
				  		
		           <div class="d-flex ml-3" style="flex-direction:column;color: #666; line-height: 25px;font-size: 14px;border-right:1px solid #ddd;width:30%;padding-right:10px">
		           	<span style="font-size:16px;font-weight: bold;">{{mem_id}},{{$t('newAdd.안녕하세요')}}!</span>
		           	
		           <span>{{$t('newAdd.등록시간')}}:{{mem_regdate}}</span>
		           	<span>{{$t('nav.비밀번호')}}:*******<el-button type="primary" icon="el-icon-edit-outline" size="mini" class=" ml-2" @click ="pass">{{$t('msg.비번수정')}}</el-button></span>

		           </div>
		            <div class="text-center " style="border-right:1px solid #ddd; width:40%">
				  	    	<h5>{{$t('nav.알잔액')}}</h5>
				  	    	<h2 v-if="this.new_almsys" class="text-danger d-flex" style="align-items:center;justify-content: center" >{{mem_cash}}<el-button  type="danger" size="mini" class="ml-2" @click="toExangeApiCash">{{$t('newAdd.전환')}}</el-button></h2>
				  	    </div>
				  	    <div class="text-center" style="width:28%">
				  	    	<h5>{{$t('msg.카슬머니')}}</h5>
				  	    	<h2 class="text-danger">{{api_money}}</h2>
				  	    </div>
				  	</div>

				  </el-col>
				
				  
				 
			</el-row>
		   <el-row :gutter="20">
				  <el-col :span="24">
				  	<h4 class="mb-3" style="padding-left:30px">Personal Information</h4>
				  	<div class="grid-content d-flex bg-white px-3 " style="justify-content:center;padding-top:20px">
				  		<table class="table table-bordered table-striped" width="80%">
									     
									      <tr>
									        <th width="20%">{{$t('nav.아이디')}}</th>
									        <td>{{mem_id}}</td>
									      </tr>

									      <tr>
									        <th width="20%">{{$t('newMsg.카롤')}}</th>
									        <td>{{event_loing_recom_e }}%</td>
									      </tr>

									      <tr>
									        <th width="20%">{{$t('newMsg.슬롤')}}</th>
									        <td>{{event_loing_recom_slot}}%</td>
									      </tr>

									      <tr v-if="pc_e>0">
									        <th width="20%">{{$t('newAdd.카루징')}}</th>
									        <td>{{pc_e}}%</td>
									      </tr>

									      <tr v-if="pc_slot>0">
									        <th width="20%">{{$t('newAdd.슬루징')}}</th>
									        <td>{{pc_slot}}%</td>
									      </tr>


									     
									       <tr>
									        <th width="20%">{{$t('tableText.예금주')}}</th>
									        <td>{{mem_bankname}}</td>
									      </tr>

									       <tr>
									        <th width="20%">{{$t('newMsg.은행')}}</th>
									        <td>{{mem_bankcode}}</td>
									      </tr>

									       <tr>
									        <th width="20%">{{$t('newMsg.계좌')}}</th>
									        <td>{{mem_banknum}}</td>
									      </tr>

									      <tr>
									        <th>{{$t('tableText.연락처')}}</th>
									        <td>{{mem_hp}}</td>
									      </tr>
									    
									     
									      <tr>
									      	<td colspan="2" style="text-align: center;"><el-button type="primary" @click="logout">{{$t('msg.로그아웃')}}</el-button></td>
									      </tr>

									     
									      
									    </table>
				  	
				  	</div>
				  </el-col>
				 
				  
				 
			</el-row>
	
			  <el-dialog 
          :visible.sync="exchangeGmApim1"
          :width="layoutWidth" :title="$t('msg.전환하기')">

          <el-form  label-width="80px" v-loading="loading" >
            <el-form-item :label="$t('nav.알잔액')" class="mb-0">
              <el-input v-model="mem_cash" class="w-50 mr-1"></el-input>
              <el-button type="primary" @click="exchaneSubmit1('api')" :loading="exchangeGmApimLoad">{{$t('newMsg.카슬머니로전환')}}</el-button>
            </el-form-item>
             <el-form-item :label="$t('msg.카슬머니')" class="mb-0" >
              <el-input v-model="api_money" placeholder=""  class="w-50 mr-1"></el-input>
              <el-button type="default" @click="exchaneSubmit1('mem_cash')" :loading="exchangeGmApimLoad">{{$t('newMsg.알잔액으로전환')}}</el-button>
            </el-form-item>
               <el-form-item  class="mb-0" >
            <span style="line-height:20px;color:rgb(200, 64, 13);display:inline-block;">
            	게임을 하실경우 "카슬머니"로 전환<br>
              하부로 알충 또는 환전하실 경우 다시 "알잔액"으로 전환</span>
            </el-form-item>
          </el-form>
        


        </el-dialog>
		  <!-- password -->
            <el-dialog 
          :visible.sync="passDialog"
          :width="pWidth">

          <el-form ref="passform" :model="passform" label-width="100px" :rules="rules">

          	<el-form-item :label="$t('tableText.현제비번')" class="mb-0" prop="thispass">
              <el-input v-model="passform.thispass"  class="w-75" type="password"></el-input>
            </el-form-item>

            
            <el-form-item :label="$t('nav.비밀번호')" class="mb-0" prop="oldpass">
              <el-input v-model="passform.oldpass"  class="w-75" type="password"></el-input>
            </el-form-item>
             <el-form-item :label="$t('nav.비밀확인')"  class="mb-0" prop="newpass">
              <el-input v-model="passform.newpass"  class="w-75" type="password"></el-input>
            </el-form-item>
          <el-form-item label="OTP" class="mb-0">
              <el-input v-model="passform.otp"  class="w-75" type="password"></el-input>
            </el-form-item>

          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="passDialog = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary":loading="layLoading"  @click="passSumbit">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog> 
		
	
	
	</div>
</template>

<script>
	import layer from '../../components/common/layer.vue';
	import layerNew from '../../components/common/layer-new.vue';
	export default {
		 components: {
				      layer,layerNew
				    },
		data() {
			return {
				
				change_btn:false,
				exchangeGmApimLoad:false,
				layoutWidth:'450px',
				exchangeGmApim1:false,
				layLoading:false,
				passform:{
    				oldpass:'',
    				thispass:'',
    				newpass:'',
    				otp:''
    			},
				pWidth:'400px',
    			passDialog:false,
				spanRow:4,
				loading:false,
				time:'',
				new_almsys:false,
				admin_id:window.sessionStorage.getItem('admin_id'),
				domain:window.sessionStorage.getItem('domain'),
				ulevel:window.sessionStorage.getItem('level'),
				power:window.sessionStorage.getItem('power'),
				new:window.sessionStorage.getItem('new'),
				mem_id:'',
				mem_regdate:'',
				event_loing_group_recom:'',
				pc_e:'',
				pc_slot:'',
				event_loing_recom:'',
				event_loing_recom_e:'',
				event_loing_recom_slot:'',
					event_loing_e:'',
				event_loing_slot:'',
					username:'',
					mem_bankname:'',
					mem_banknum:'',
					mem_bankno:'',
					mem_hp:'',
					mem_bankcode:'',
					mem_cash:'',
					api_money:'',
				
				rules: {
                  oldpass:[{ required: true, message: '', trigger: 'blur'}],
                  newpass:[{ required: true, message: '', trigger: 'blur'}],
                  thispass:[{ required: true, message: '', trigger: 'blur'}],
              },
				searchform:{
					time:[],
    				keyword:'',
    				searchOptions:[
             
			             {
			             label:this.$i18n.t("msg.전체"),
			              value:''
			            } 
		        ],
		       
		        value:'',
    			},
    			 pickerOptions: {
    			},
         shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
			
				
				
			}
		},
		
		created(){
			console.log('screen.width',screen.width)
     
			if(screen.width<1200)
			{
             //手机
             this.spanRow = 8
			}

            this.mypage();
            this.new_almsys = window.sessionStorage.getItem('new_almsys')
			
			
		},
		mounted() {
		
		},
		methods: {
			exchaneSubmit1(v){
				
    			let token=window.sessionStorage.getItem('user');
    			let money=0;
    			if(v=='mem_cash')
    			{
            money=this.api_money
    			}else
    			{
    				 money=this.mem_cash
           
    			}

    			if(this.change_btn)
    			{
    				return;
    			}
this.exchangeGmApimLoad = true
    			this.change_btn=true;
          this.$axios({
                      method:'post',
                      
                      url:this.domain+'/user/exchange_gm_apim?type='+v+'&cash='+money,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                  	this.change_btn=false;
                    this.exchangeGmApimLoad = false
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })

                      this.mem_cash=response.data.mem_cash
                      this.api_money=response.data.api_money
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    // this.getList()
    
                  }).catch((error) =>{
                      this.change_btn=false;
                  })
                  
    		},
			pass(){
				this.passDialog = true
			},
			logout(){
				window.sessionStorage.clear();

	        	document.title='';
	        	//window.localStorage.clear();
                localStorage.setItem('navActive',JSON.stringify({
					top:'0',
					left:'memlist_list'
				})) 
          
			
			
	        	this.$router.push({name:'login'})
			},
			toExangeApiCash(){

    			 if(this.new_almsys!="1")
    			 {
              return;
    			}
    			this.exchangeGmApim1 = true

    			 let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/user/money_info'
          
    
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 

                   
                   
                    this.mem_cash = response.data.data.mem_cash
                    this.api_money = response.data.data.api_money
                  
                    
               
            }).catch((error) =>{
              

               this.$message.error(error);
               
               
               
            })

    		},
			mypage(){
    		
    			 let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/user/mypage'
          
    
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 

                   
                   
                   console.log('mypage',response.data.data)
                   let item = response.data.data
                  this.mem_id = item.mem_id
									this.mem_regdate = item.mem_regdate


								  this.event_loing_recom_e = item.event_loing_recom_e
									this.event_loing_recom_slot = item.event_loing_recom_slot

									if(response.data.user_type=='user')
									{
	this.event_loing_e = item.event_loing_e
									this.event_loing_slot = item.event_loing_slot
									}

								
								
									this.pc_e = item.pc_e
									this.pc_slot = item.pc_slot
									this.mem_bankname = item.mem_bankname
									this.mem_banknum = item.mem_banknum
									this.mem_bankno = item.mem_bankno
									this.mem_bankcode = item.mem_bankcode
									this.mem_hp = item.mem_hp
									this.mem_cash = item.mem_cash
									this.api_money = item.api_money

                    
               
            }).catch((error) =>{
              

               this.$message.error(error);
               
               
               
            })

    		},
			passSumbit(){
              let token=window.sessionStorage.getItem('user');
               if(this.passform.newpass !== this.passform.oldpass)
              {
                 this.$message({
                    message:'비번이 일치하지않습니다',
                    type: 'warning'
                  });
                  return;
              }
              this.$refs.passform.validate((e)=>{
             if(!e) return;
              this.$axios({
                    method:'post',
                    url:this.domain+'/user/admin_pwd_up',
                    data:{
                      pwd:this.passform.newpass,
                      tpwd:this.passform.thispass,
                     
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 

                    if(response.data.code==200){

                       this.passDialog = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })

                         window.sessionStorage.clear();
                         this.$router.push({name:'login'})
                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
    
              }).catch((error) =>{
                  console.log(error)       //请求失败返回的数据
              })

             })
             
        },
			 openModel(id){
			          if(this.new=='1')
			           {
			                this.$layer.iframe({
			                type: 2,
			                title: '',
			                content: {
			                    content: layerNew,
			                    parent: this,
			                    data:{
			                    info:{id:id},
			                    layerid:'id'
			                    }
			                  
			                },
			                shadeClose: false,
			                maxmin:true,
			                shade: false,
			                area: ['830px', '680px'],
			             
			             });
			              return;
			           }
			            this.$layer.iframe({
			            type: 2,
			            title: '',
			            content: {
			                content: layer,
			                parent: this,
			                data:{
			                info:{id:id},
			                layerid:'id'
			                }
			              
			            },
			            shadeClose: false,
			            maxmin:true,
			            shade: false,
			            area: ['830px', '680px'],
			         
			        });
			        },
			
			
		},
	}
</script>

<style>
 .el-row {
    margin-bottom: 20px;
   
  }
  .el-col {
    border-radius: 4px;
  }
  
  .grid-content {
    border-radius: 4px;
   
  }
 .bg-prink{
 	background-color: #03c0d1 !important;
 }
 .bg-black{
 	background: #666a7f !important;
 }
 .bg-success-1{
 	background: #6bcab5 !important;
 }
 .bg-pink{
 	background-color: #df7796 !important;
 }
 .bg-warn{	background-color: #d0ab2c !important;}
 .bg-suc{
 	background-color: #a1c264 !important;
 }
</style>



// WEBPACK FOOTER //
// src/views/mypage/index.vue